import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sideBar: {
    pays: "",
    region: "",
    commune: "",
    dateDebut: "",
    dateFin: "",
    adult: 1,
    enfant: 0,
    room: 1,
    budget: "0-199999",
    type: [],
    repas: "",
    conditions: "",
    equipement: [],
  },
  url: "",
  redirect:false,
  responseHeberg : []
};

export const sbHebergSlice = createSlice({
  name: "sbHeberg",
  initialState,
  reducers: {
    sideBarHeberg: (state, action) => {
      state.sideBar = action.payload;
      //create url with params to be pushed
      state.url = Object.entries(state.sideBar).filter(([key, val]) => val != null && val != "").map(([key, val]) => `${key}=${val}`).join('&').replaceAll(' ',"+")
      state.redirect = true
    },
    redirect:(state, action)=>{
      state.redirect = action.payload
    },
    searchedHb:(state,action)=>{
      state.responseHeberg = action.payload
    }
    },
});
export const { sideBarHeberg , redirect, searchedHb} = sbHebergSlice.actions;

export default sbHebergSlice.reducer;
